import type {ReactElement} from 'react';
import React from 'react';
import {BaseFontSizeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-font-size-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTextStylesActiveItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesActiveItem';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

export function ItemSizeOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fontSize = useGetKeyFromTextStylesActiveItem('fontSize');
  const scaleX = useGetKeyFromActiveItem('scaleX');

  if (!activeItem || (activeItem && !('textStyles' in activeItem)) || fontSize === undefined || scaleX === undefined) {
    throw new Error(`Item doesn't have text styles attribute`);
  }

  const updateFontSize = (fontSize: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          fontSize,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseFontSizeOption fontSize={fontSize} scale={scaleX} onUpdateFontSize={updateFontSize} />;
}
